import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CustomFontAwesomeIcon({
    title = "",
    icon,
    onClick = undefined,
    className = "",
    style = {}
}) {
    return (
        <label title={title}>
            <FontAwesomeIcon
                icon={icon}
                className={`${onClick ? "cursor-pointer" : ""} ${className}`}
                style={style}
                onClick={onClick}
            />
        </label>
    );
}
